import React, { useContext } from 'react'
import PriceRowTaxesAndFees from 'components/Luxkit/PricePoints/PriceRowTaxesAndFees'
import GeoContext from 'contexts/geoContext'
import Group from 'components/utils/Group'
import TextButton from 'components/Luxkit/Button/TextButton'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import WalledContent from 'components/Common/WalledContent'
import { connect } from 'react-redux'
import OfferTileLoggedInButtons from 'components/OfferList/OfferListTiles/Support/OfferTileLoggedInButtons'
import { hasPassedWalledGarden } from 'selectors/accountSelectors'
import config from 'constants/config'
import { pluralizeToString } from 'lib/string/pluralize'
import LinePlaneDepartureIcon from 'components/Luxkit/Icons/line/LinePlaneDepartureIcon'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import PriceRowValueDiscountWithCaption from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscountWithCaption'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary | App.BedbankOfferWithRate;
  homepageAndVertical?: boolean;
}

interface MappedStateProps {
  hasPassedWall: boolean,
}

function BedbankOfferPriceDetails(props: Props & MappedStateProps) {
  const {
    offer,
    hasPassedWall,
    homepageAndVertical,
  } = props
  const { currentRegionHasFlights } = useContext(GeoContext)
  const showFlightPricingDetails = !offer.walledGarden && currentRegionHasFlights && offer.flights.flightsEnabled && !homepageAndVertical
  const hotelPrice = offer.sell?.price
  const hotelValue = offer.sell?.value ?? 0
  const hotelDiscount = offer.sell?.discount ?? 0
  const hotelNights = offer.sell?.los ?? 0
  const durationText = `${pluralizeToString('night', hotelNights)} from`
  const noPriceAvailable = hotelPrice === undefined
  const showViewButton = (noPriceAvailable || (hasPassedWall || !offer.walledGarden) && !noPriceAvailable) && !homepageAndVertical

  const wall = (
    <OfferTileLoggedInButtons
      signUpText="Sign up for free"
      align="none"
      fullWidth={false}
      mdFullWidth={homepageAndVertical}
    />
  )
  return (
    <Group
      direction={homepageAndVertical ? 'vertical' : 'horizontal'}
      horizontalAlign={!hasPassedWall && offer.walledGarden ? 'end' : 'space-between'}
      verticalAlign="end"
    >
      <Group
        desktopHorizontalAlign={homepageAndVertical ? 'center' : 'start'}
        direction="vertical"
      >
        {!noPriceAvailable && <>
          <WalledContent enforced={offer.walledGarden} wall={wall}>
            <PriceRowPriceCaption>{durationText}</PriceRowPriceCaption>
            <PriceRowPrice
              size="L"
              price={hotelPrice}
              saleUnit={offer.saleUnit}
              taxesAndFees="inclusive"
            />
            <PriceRowTaxesAndFees taxesAndFees="inclusive" />
            {hotelDiscount > 0 && <PriceRowValueDiscountWithCaption
              size="L"
              value={Math.ceil(hotelValue)}
              discountPercentage={hotelDiscount > config.displayDiscountThreshold.bedbank ? Math.ceil(hotelDiscount * 100) : undefined}
            />}
          </WalledContent>
          {showFlightPricingDetails && <CaptionTextBlock
            variant="large"
            wrap="pre-wrap"
            startIcon={<LinePlaneDepartureIcon colour="neutral-one" />}
          >
            Hotel + flight package available
          </CaptionTextBlock>}
        </>}
      </Group>
      <CSSBreakpoint min="desktop">
        {showViewButton &&
          <TextButton kind="primary" nonInteractable>
            View
          </TextButton>
        }
      </CSSBreakpoint>
    </Group>
  )
}

export default connect<MappedStateProps, undefined, Props, App.State>((appState) => {
  return {
    hasPassedWall: hasPassedWalledGarden(appState),
  }
})(BedbankOfferPriceDetails)
